export default "__VITE_ASSET__BA8i31AG__"